import EditEntityJurisdictionActionButtons from './EditEntityJurisdictionActionButtons';

export default EditEntityJurisdictionActionButtons;
